import React, { useEffect } from "react";
import { renderRoutes } from "react-router-config";
import { useDispatch } from "react-redux";
import { configureScope } from "@sentry/browser";
import { ThemeProvider } from "styled-components";
import { GoogleOAuthProvider } from "@react-oauth/google";

import Footer from "../../components/Footer";
import ErrorBoundary from "../../components/ErrorBoundary";
import ScrollToTop from "../../components/ScrollToTop";
import NewVersionAvailable from "../../app/NewVersionAvailable";
import Notifications from "../../app/Notifications";
import GlobalCss from "../../style";
import getUser from "../../store/user/actions/getUser";
import { useUser } from "../../store/user/selectors";

import theme from "../style/theme";
import Nav from "../components/Nav";

import { IProps } from "./interfaces";
import { googleClientId } from "../../../common/parameters";
import { useIntl } from "react-intl";
import { showNotification } from "../../store/notification/actions";


const App = ({ route }: IProps) => {
    const user = useUser();
    const dispatch = useDispatch();
    const intl = useIntl();

    useEffect(() => {
        if (!user || !user.loggedIn) {
            if (process.env.NODE_ENV === "development") {
                dispatch(getUser());
            }
        } else {
            const { _id: id, email } = user;
            configureScope(scope => {
                scope.setUser({
                    id,
                    email,
                });
            });
        }
        if (intl.locale !== "hu") {
            dispatch(showNotification(intl.formatMessage({ id: "choir.countryRestriction" }), "hint"))
        }
    }, []);
    if (user === null) return null;
    return (
        <GoogleOAuthProvider clientId={googleClientId}>
            <div>
                <ThemeProvider theme={{
                    ...theme,
                    mode: "light",
                }}>
                    <>
                        <GlobalCss />
                        <ErrorBoundary>
                            <Nav />
                            <ScrollToTop>{renderRoutes(route.routes)}</ScrollToTop>
                            <NewVersionAvailable />
                            <Footer />
                            <Notifications />
                        </ErrorBoundary>
                    </>
                </ThemeProvider>
            </div>
        </GoogleOAuthProvider>
    );
}

export default App;
